import { render, staticRenderFns } from "./ResidenceList.vue?vue&type=template&id=3de6a4a7&"
import script from "./ResidenceList.vue?vue&type=script&lang=js&"
export * from "./ResidenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports